import { get, map } from 'lodash';
import { Header, TopHeader } from '@/types/Table';

export const createTableHeaders = (config: Array<Header>) => {
  return map(
    config,
    header =>
      ({
        key: get(header, 'key', ''),
        cellClasses: get(header, 'cellClasses', []),
        classes: get(header, 'classes', []),
        componentType: get(header, 'componentType', ''),
        dividerRight: get(header, 'dividerRight', false),
        headerComponentType: get(header, 'headerComponentType', ''),
        footerComponentType: get(header, 'footerComponentType', ''),
        footerSpan: get(header, 'footerSpan', 1),
        sortable: get(header, 'sortable', false),
        topHeader: get(header, 'topHeader', ''),
        visibility: get(header, 'visibility', ''),
        footnoteSymbol: get(header, 'footnoteSymbol', ''),
        headerTranslationOverride: get(header, 'headerTranslationOverride', ''),
        testIdOverride: get(header, 'testIdOverride', ''),
        linkExtra: get(header, 'linkExtra', {}),
      } as Header)
  );
};

export const createTopTableHeaders = (config: Array<TopHeader>) => {
  return map(
    config,
    header =>
      ({
        key: get(header, 'key', ''),
        dividerRight: get(header, 'dividerRight', false),
        headerComponentType: get(header, 'headerComponentType', ''),
        classes: get(header, 'classes', []),
        visibility: get(header, 'visibility', ''),
      } as TopHeader)
  );
};

export const sumColumn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<any>,
  col: string,
  clientSpecific = false
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return data.reduce((acc: number, item: any) => {
    const value = clientSpecific
      ? item.clientSpecificValues[col].dataValue
      : item[col].dataValue;
    return acc + Number(value);
  }, 0);
};
